import { endpoints } from '../assets/server/endpoints';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  keycloak: {
    //  REMEMBER THIS OBJECT IS ONLY FOR DEVELOPING PURPOSES. PLEASE, KEEP IN MIND THAT THIS CONFIG WILL
    //  BE OVERWRITE WITH APP-ENV.JS PRESENT IN THE REPO CONFIG FOLDER OF YOUR PROJECT.
    //  Url of the Identity Provider
    issuer: 'your_issuer_url',

    // Realm
    realm: 'stl-int',

    // The SPA's id.
    // The SPA is registerd with this id at the auth-server
    clientId: 'your_client_id'
  },

  // Old
  // serverUrl: 'Sos-Apis-Test/',
  // DEV
  // pMediadorXAPIKey: '246769fcedafcdef844f2a325383c42e',
  // productMediador: 'https://sldev.santalucia.es/',
  // urlBaseOWCS: 'http://adm.wcs.dev.oci.santalucia.net:7003/',
  // urlBaseOWCS: 'https://irisglobal.wcs.dev.oci.santalucia.net/sites/REST/', // DEV
  // Test - PRE
  production: false,
  // GTM_KEY: 'GTM-KV6WMDB',
  // serverUrl: 'VASS-APIS-TEST/',
  // redsysRedirectUrl: 'https://sis-t.redsys.es:25443/sis/realizarPago',
  // redsysKey: 'sq7HjrUOBfKmC576ILgskD5srU870gJ7',
  // pardotAPIKey: '6d6f1b59781c6bd0b6fe85febab65712',
  // pMediadorXAPIKey: '65a1699eeff011edbe49a99b2da1f371',
  // productMediador: 'https://sltest.santalucia.es/',
  // urlBaseOWCS: 'http://10.60.4.162:6680/sites/REST/', // TEST IP
  // urlBaseOWCS: 'https://wwwtst.irisglobal.es/sites/REST/', // TEST
  // redsysBizumRedirectUrl: 'https://sis-t.redsys.es:25443/sis/realizarPago',  // real: https://sis.redsys.es/sis/realizarPago
  // apikey: '7d1b61478a3911ef8cd3cd24a31e207c', // DEV
  // apikey: '4514e03e7fec11ef8cd36b41513bc039', // TEST
  apikey: '4bea286aa1a411ef993ad94a17bceaa5 ', // PRO
  endpoints,
  // PRO
  // production: true,
  GTM_KEY: 'GTM-TRZB6L2',
  // serverUrl: 'VASS-APIS-PROD/',
  redsysRedirectUrl: 'https://sis.redsys.es/sis/realizarPago',
  pardotAPIKey: 'edf07afce33711edbe494bf01b96ca5c',
  redsysKey: '7PkgsexEk9Fb/C1m2nbJgVx1Hf3aJa3f',
  // pMediadorXAPIKey: 'e4efcd862c5411ee9e6039cbf88f60b9',
  productMediador: 'https://apis.santalucia.es/',
  urlBaseOWCS: 'https://www.irisglobal.es/sites/REST/', // PRO
  redsysBizumRedirectUrl: 'https://sis.redsys.es/sis/realizarPago',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

